module.exports = __webpack_public_path__ + "img/partner_icon3.f5798a97.png";